import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import DropdownVM, { Dropdown } from '../base/base';
import './list.html';

@injectable()
export default class ListDropdownVM extends DropdownVM {
    headerNodes: JQuery<any>
    bodyNodes: JQuery<any>

    constructor(
        @inject(wccModules.componentConfig) model: Dropdown,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super(model, info);

        this.headerNodes = $(info.templateNodes).filter('list-head').contents();
        this.bodyNodes = $(info.templateNodes).filter('list-body').contents();
    }

    protected override checkIfAlwaysShown() {
        return true;
    }
}